import './App.css';
import Aos from "aos";
import "aos/dist/aos.css";
import React from 'react'
import Navbar from './components/Navbar';
import About from './sections/About';
import Skills from './sections/Skills';
import Experience from './sections/Experience';
import Projects from './sections/Projects';
import Footer from './components/Footer';
import Contact from './sections/Contact';
import BarLoader from 'react-spinners/BarLoader';
import { Text } from '@chakra-ui/react';

export default function App() {

  const [loading, setLoading] = React.useState(false);

  React.useEffect(() => {
    Aos.init({ duration: 2000 });
    setLoading(true);
    setTimeout(() => {
      setLoading(false);
    }, 2000);
  }, [])



  return (
    <React.Fragment>
      {
        loading ?
        <div className='loader animate__animated animate__fadeIn'>
          <Text fontSize={"lg"}>Welcome to Aryamitra's Portfolio!</Text>
          <BarLoader color="#1FA2FF" loading={loading}/> 
        </div>
        : (
          <>
            <Navbar />
            <About />
            <Skills />
            <Experience />
            <Projects />
            <Contact />
            <Footer />
          </>
        )
      }
    </React.Fragment>
  )
}

